"use client";

import * as React from "react";

import { composeRefs } from "@/utils/compose-refs";
import { cn } from "@/utils/lib";

type SlotProps = React.HTMLAttributes<HTMLElement> & {
  children?: React.ReactNode;
};

const Slot = ({
  ref,
  children,
  className,
  style,
  ...props
}: SlotProps & {
  ref?: React.Ref<HTMLElement>;
}) => {
  const { nativeButton, ...slotProps } = props as typeof props & {
    nativeButton?: boolean;
  };
  void nativeButton;
  const child = React.Children.only(children) as React.ReactElement<{
    className?: string;
    ref?: React.Ref<HTMLElement>;
    style?: React.CSSProperties;
  }>;

  if (!React.isValidElement(child)) {
    return null;
  }

  const childProps = child.props;

  return React.cloneElement(child, {
    ...slotProps,
    ...childProps,
    className: cn(className, childProps.className),
    style: {
      ...style,
      ...childProps.style,
    },
    ref: composeRefs(ref, childProps.ref),
  } as React.HTMLAttributes<HTMLElement>);
};

Slot.displayName = "Slot";

export { Slot };
